import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Communicator from 'models/communicator';
import connect from 'components/lib/connect';
import ConversationItem from 'models/conversation_item';
import InteractionType from 'models/interaction_type';
import ItemContent from '../item_content';
import Metadata from 'components/customer/conversation_history/conversation_items_v2/metadata/metadata';
import { SessionEndReason } from 'models/session_ended';

export function SessionEndedItem({ currentAgentId, initiatorName, item }) {
  const text = getMessageText();
  if (!text) {
    return null;
  }

  return (
    <ItemContent isAuditItem item={item}>
      <Metadata subject={getSubject()} text={text} timestamp={item.timestamp} />
    </ItemContent>
  );

  function getMessageText() {
    switch (item.content.reason) {
      case SessionEndReason.CUSTOMER_NO_REPLY: {
        let interval = `${item.content.timeout} minute${item.content.timeout !== 1 ? 's' : ''}`;
        return _.template(getMessageTemplate(item.content.sessionType, item.content.reason))({ interval });
      }
      case SessionEndReason.TIME_EXPIRED: {
        let interval = `${item.content.timeout} hour${item.content.timeout > 1 ? 's' : ''}`;
        return _.template(getMessageTemplate(item.content.sessionType, item.content.reason))({ interval });
      }
      default:
        return getMessageTemplate(item.content.sessionType, item.content.reason);
    }
  }

  function getSubject() {
    if (item.content.reason !== SessionEndReason.AGENT_ENDED) {
      return null;
    }

    if (currentAgentId === _(item).get('initiator.id')) {
      return 'You';
    }

    return initiatorName || 'An agent';
  }
}

function getMessageTemplate(sessionType, sessionEnd) {
  return _(messageTemplates).get([sessionType, sessionEnd], '');
}

let messageTemplates = {
  [InteractionType.CHAT]: {
    [SessionEndReason.AGENT_ENDED]: 'ended the chat',
    [SessionEndReason.CUSTOMER_NO_REPLY]: `Customer did not respond to chat within <%= interval %>`,
    [SessionEndReason.STARTED_NEW]: [
      'The customer signed in from a new location. Please use your',
      <br key={99} />,
      'best judgment before sharing out sensitive information.',
    ],
    [SessionEndReason.TIME_EXPIRED]: `Chat with customer ended because of inactivity for <%= interval %>`,
  },
  [InteractionType.FB_MESSENGER]: {
    [SessionEndReason.CUSTOMER_NO_REPLY]: `Customer did not respond to Facebook message within <%=interval %>`,
  },
  [InteractionType.SMS]: {
    [SessionEndReason.CUSTOMER_NO_REPLY]: `Customer did not respond to SMS within <%=interval %>`,
  },
  [InteractionType.WHATSAPP]: {
    [SessionEndReason.CUSTOMER_NO_REPLY]: `Customer did not respond to WhatsApp message within <%=interval %>`,
    [SessionEndReason.TIME_EXPIRED]: `WhatsApp conversation with customer ended because of inactivity for <%= interval %>`,
  },
};

SessionEndedItem.propTypes = {
  currentAgentId: PropTypes.string.isRequired,
  initiatorName: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

function mapStateToProps({ getProvider }, { item }) {
  let agents = getProvider('agents');
  let currentAgentId = getProvider('currentAgent').get().id;

  return {
    currentAgentId,
    initiatorName: getInitiatorName() || null,
    item,
  };

  function getInitiatorName() {
    return (
      _(item).get('initiator.type') === Communicator.AGENT && _(agents.findBy({ id: item.initiator.id })).get('name')
    );
  }
}

const SessionEndedItemContainer = connect(mapStateToProps)(SessionEndedItem);

SessionEndedItemContainer.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export default SessionEndedItemContainer;
